import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import { Modal, Button, Alert, Spinner } from "react-bootstrap";
import axios from "axios";
import Baseurl from "../../../Baseurl";
import { useHistory } from "react-router-dom";
import { Multiselect } from "multiselect-react-dropdown";
import swal from "sweetalert";
const ViewOrdersList = (props) => {
  const { id } = props.match.params;
  const history = useHistory();
  const sort = 10;
  const activePag = useRef(0);
  const [data, setData] = useState([]);
  const [allTest, setAllTest] = useState([]);
  const [allPackage, setAllPackages] = useState([]);
  const [name, setName] = useState("");
  const [areaName, setAreaName] = useState("");
  const [orderId, setOrderId] = useState("");
  const [userId, setUserId] = useState("");
  const [address, setAddress] = useState("");
  const [contact, setContact] = useState("");
  const [lat, setLat] = useState("");
  const [long, setLong] = useState("");
  const [cityName, setCityName] = useState("");
  const [pincode, setPincode] = useState("");
  const [selectedTest, setSelectedTest] = useState([]);
  const [selectedPackage, setSelectedPackage] = useState([]);
  const [packageAmount, setPackageAmount] = useState("");
  const [testAmount, setTestAmount] = useState("");
  const [spinner, setSpinner] = useState(true);
  const [riderSpinner, setRiderSpinner] = useState(false);
  const [test, settest] = useState(0);
  const [show, setShow] = useState(false);
  const [show1, setShow1] = useState(false);
  const [findRider, setFindRider] = useState(false);
  const [orders, setOrders] = useState([]);
  const handleClose = () => setShow(false);
  const [searchData, setSearchData] = useState([]);
  // Active data
  const chageData = (frist, sec) => {
    for (var i = 0; i < data.length; ++i) {
      if (i >= frist && i < sec) {
        data[i].classList.remove("d-none");
      } else {
        data[i].classList.add("d-none");
      }
    }
  };
  function getData(length) {
    axios
      .get(
        Baseurl.baseurl + `/health/health-center-orders/${id}/${length}`
      )
      .then((res) => {
        if (res.data.status) {
          setSpinner(false);
          setOrders(res.data.details);
          setSearchData(res.data.details);
          setData(document.querySelectorAll("#job_data tbody tr"));
        }
      })
      .catch((err) => {
        // if(err.toString()==="Error: Network Error")
        // {
        //   history.push('/offline')
        // }
        // else
        // {
        //   history.push('/400')
        // }
      });
  }
  useEffect(() => {
    getData(0);
  }, []);

  activePag.current === 0 && chageData(0, sort);
  let paggination = Array(Math.ceil(data.length / sort))
    .fill()
    .map((_, i) => i + 1);
  const onClick = (i) => {
    activePag.current = i;
    chageData(activePag.current * sort, (activePag.current + 1) * sort);
    settest(i);
  };

  function searchRider(value) {
    let filteredData = [];
    searchData.map((val) => {
      if (val._id.toLowerCase().includes(value)) {
        filteredData.push(val);
      }
    });
    setOrders(filteredData);
  }
  function getAllTest() {
    axios
      .get(Baseurl.baseurl + "/health/get-all-health-test")
      .then((res) => {
        setAllTest(res.data.data);
      });
  }
  function getAllPackage() {
    axios
      .get(Baseurl.baseurl + "/health/get-all-health-package-info")
      .then((res) => {
        setAllPackages(res.data.data);
      });
  }
  function createOrderFunction() {
    // axios
    //   .get(Baseurl.baseurl + `/user/get-user-by-phone/7259607409`)
    //   .then((res) => {
    //     console.log("user result", res);
    //     setAllTest(res.data.data);
    //   });
    setShow(true);
    setFindRider(false);
    getAllTest();
    getAllPackage();
  }
  const selection1 = (selectedValues) => {
    let id = [];
    let amt = [];

    selectedValues.map((val) => {
      amt.push(val.OfferPrice);
      id.push({
        Count: val.Count,
        Description: val.Description,
        Image: val.Image,
        Name: val.Name,
        OfferPrice: val.OfferPrice,
        Price: val.Price,
        Tests: val.Tests.map((val) => val._id),
      });
    });
    let sum = amt.reduce((partialSum, a) => partialSum + a, 0);
    console.log("selected pack", sum);
    setPackageAmount(sum);
    setSelectedPackage(id);
  };
  const selection2 = (selectedValues) => {
    let id = [];
    let amt = [];
    selectedValues.map((val) => {
      amt.push(val.OfferPrice);
      id.push({
        Count: val.Count,
        Description: val.Description,
        Image: val.Image,
        Name: val.Name,
        OfferPrice: val.OfferPrice,
        Price: val.Price,
        SubTest: val.SubTest.map((val) => val._id),
        TubeType: val.TubeType,
        Type: val.Type,
      });
    });
    let sum = amt.reduce((partialSum, a) => partialSum + a, 0);
    setPackageAmount(sum);
    setSelectedTest(id);
  };
  function createOrder(e) {
    e.preventDefault();
    let data = {
      address: [
        {
          Name: name,
          AreaName: areaName,
          Address: address,
          Lat: lat,
          Lon: long,
          Contact: contact,
          Origin: true,
          CityName: cityName,
        },
      ],
      Amount: testAmount + packageAmount,
      pincode: pincode,
      userID: "",
      duration: 5,
      CustomerRegistrationToken: "",
      tests: selectedTest,
      packages: selectedPackage,
      paid: false,
    };
    let orderData = {
      data: JSON.stringify(data),
    };
    console.log("datsaa", data);
    axios
      .post(Baseurl.baseurl + `/health/create-health-order`, orderData)
      .then((response) => {
        if (response.data.status) {
          swal("successfully created", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
        } else {
          swal("oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
        setShow(false);
      })
      .catch((err) => {});
  }
  function findRiderFunction() {
    setRiderSpinner(true);
    let riderData = {
      orderID: orderId,
      userID: userId,
    };
    axios
      .post(Baseurl.baseurl + `/health/find-health-rider`, riderData)
      .then((response) => {
        if (response.data.status) {
          swal("successfully Triggered", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
        } else {
          swal("oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
        setShow(false);
        setRiderSpinner(false);
      })
      .catch((err) => {});
  }
  function deleteOrder() {
    let riderData = {
      orderID: orderId,
      userID: userId,
    };
    axios
      .put(
        Baseurl.baseurl + `/health/delete-health-order/${orderId}`,
        riderData
      )
      .then((response) => {
        if (response.data.status) {
          swal("successfully Deleted", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
          getData();
        } else {
          swal("oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
        setShow1(false);
      })
      .catch((err) => {});
  }
  useEffect(() => {
    if (data.length > 0) {
      if (props.location.state !== undefined) {
        window.scrollTo({
          top: parseInt(props.location.state.position),
          behavior: "smooth",
        });
      }
      onClick(
        props.location.state === undefined
          ? 0
          : parseInt(props.location.state.pagination)
      );
      setOrders([...orders]);
    }
  }, [data]);
  useEffect(() => {
    if (props.location.state === undefined) {
      getData(orders.length);
    } else {
      setOrders(props.location.state.data);
      setSpinner(false);
      setTimeout(() => {
        setData(document.querySelectorAll("#job_data tbody tr"));
      }, 50);
    }
  }, []);
  return (
    <div className="col-12">
      <Modal
        size="lg"
        show={show1}
        onHide={() => {
          setShow1(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete Order</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          <h4>Are you sure !! you want to delete this order ? </h4>
        </Modal.Body>
        <Modal.Footer>
          <button
            onClick={() => {
              deleteOrder();
            }}
            className="btn btn-danger"
          >
            Delete
          </button>
        </Modal.Footer>
      </Modal>
      <Modal size="lg" show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>
            {" "}
            {findRider ? "Find Rider" : "Create Order"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {findRider ? (
            <h4>Search the rider near to the location</h4>
          ) : (
            <form
              onSubmit={(e) => {
                createOrder(e);
              }}
            >
              <div className="row">
                <div className="col-sm-8" id="multiselect">
                  <label>Packages</label>
                  <Multiselect
                    closeIcon="close"
                    options={allPackage}
                    displayValue="Name"
                    onSelect={selection1}
                    onRemove={selection1}
                  />
                </div>
              
              
              </div>
              <div className="row">
              <div className="col-sm-8 " id="multiselect">
                  <label>Tests</label>
                  <Multiselect
                    closeIcon="close"
                    options={allTest}
                    displayValue="Name"
                    onSelect={selection2}
                    onRemove={selection2}
                  />
                </div>
              </div>
              <div className="row mt-4">
              <div className="col-sm-4" id="multiselect">
                  <label>Name</label>
                  <input
                    value={name}
                    type="text"
                    className="form-control"
                    placeholder="enter User Name"
                    onChange={(e) => setName(e.target.value)}
                    required
                  />
                </div>
                <div className="col-sm-4 " id="multiselect">
                  <label>Area Name</label>
                  <input
                    value={areaName}
                    type="text"
                    className="form-control"
                    placeholder="enter Area Name"
                    onChange={(e) => setAreaName(e.target.value)}
                    required
                  />
                </div>
                <div className="col-sm-4" id="multiselect">
                  <label>Address</label>
                  <input
                    value={address}
                    type="text"
                    className="form-control"
                    placeholder="enter full address"
                    onChange={(e) => setAddress(e.target.value)}
                    required
                  />
                </div>
               
              </div>
              <div className="row mt-4">
              <div className="col-sm-4 " id="multiselect">
                  <label>Contact No</label>
                  <input
                    value={contact}
                    type="text"
                    maxLength={10}
                    className="form-control"
                    placeholder="enter contact Number"
                    onChange={(e) => {
                      setContact(e.target.value);
                      if (e.target.value.length === 10) {
                        axios
                          .get(
                            Baseurl.baseurl +
                              `/user/get-user-by-phone/${e.target.value}`
                          )
                          .then((res) => {
                            if (!res.data.status) {
                              let userData = {
                                Email: "",
                                Phone: e.target.value,
                                Name: name,
                              };
                              axios
                                .post(
                                  Baseurl.baseurl +
                                    `/user/register-new-user-health`,
                                  userData
                                )
                                .then((response) => {
                                  if (response.data.status) {
                                    swal(
                                      "successfully user Created",
                                      response.data.message,
                                      "success",
                                      {
                                        button: "Done",
                                        timer: 1000,
                                      }
                                    );
                                  } else {
                                    swal(
                                      "oops",
                                      response.data.message,
                                      "error",
                                      {
                                        button: "Done",
                                        timer: 1000,
                                      }
                                    );
                                  }
                                })
                                .catch((err) => {});
                            }
                          });
                      }
                    }}
                    required
                  />
                </div>
                <div className="col-sm-4" id="multiselect">
                  <label>Latittude</label>
                  <input
                    value={lat}
                    type="number"
                    className="form-control"
                    placeholder=""
                    onChange={(e) => setLat(e.target.value)}
                    required
                  />
                </div>
                <div className="col-sm-4" id="multiselect">
                  <label>Longittude</label>
                  <input
                    value={long}
                    type="number"
                    className="form-control"
                    placeholder=""
                    onChange={(e) => setLong(e.target.value)}
                    required
                  />
                </div>
              
              </div>

              <div className="row mt-4">
              <div className="col-sm-4" id="multiselect">
                  <label>City Name</label>
                  <input
                    value={cityName}
                    type="text"
                    className="form-control"
                    placeholder=""
                    onChange={(e) => setCityName(e.target.value)}
                    required
                  />
                </div>
                <div className="col-sm-4" id="multiselect">
                  <label>Pincode</label>
                  <input
                    value={pincode}
                    type="text"
                    className="form-control"
                    maxLength={6}
                    placeholder=""
                    onChange={(e) => setPincode(e.target.value)}
                    required
                  />
                </div>
              </div>
              <div>
                <input
                  className="btn btn-primary mt-4 float-right"
                  type="submit"
                  value="submit"
                />
              </div>
            </form>
          )}
        </Modal.Body>
        {findRider && (
          <Modal.Footer>
            {riderSpinner ? (
              <div className="float">
                <Spinner animation="border" variant="primary" />
              </div>
            ) : (
              <button
                onClick={() => {
                  findRiderFunction();
                }}
                className="btn btn-primary"
              >
                Confirm
              </button>
            )}
          </Modal.Footer>
        )}
      </Modal>
      <div
        className="card"
        style={{
          color: "white",
          background:
            "linear-gradient(90deg, #135334 0%, #98e7c1 100%)",
        }}
      >
        <div className="card-header">
          <div>
            <input
              type="text"
              className="form-control"
              placeholder="Search here..."
              onChange={(e) => {
                searchRider(e.target.value);
              }}
            />
          </div>
          <button
            onClick={() => {
              createOrderFunction();
            }}
            className="btn btn-primary"
          >
            Create Order
          </button>
          <button
            className="btn btn-primary"
            onClick={() => {
              history.goBack();
            }}
          >
            Back
          </button>
        </div>
        <div className="card-body">
          <div className="table-responsive">
            <div id="job_data" className="dataTables_wrapper ">
              {spinner ? (
                <div className="text-center">
                  <Spinner animation="border" variant="primary" />
                </div>
              ) : (
                <table
                  className="display w-100 dataTable  "
                  id="myTable"
                  role="grid"
                  aria-describedby="example5_info"
                >
                  <thead>
                    <tr role="row">
                      <th className="text-white" rowSpan="1" colSpan="1">
                        Order ID
                      </th>

                      <th className="text-white" rowSpan="1" colSpan="1">
                        Payment Type
                      </th>
                      <th className="text-white" rowSpan="1" colSpan="1">
                        Order Status
                      </th>
                      <th className="text-white" rowSpan="1" colSpan="1">
                        Date
                      </th>
                      <th className="text-white" rowSpan="1" colSpan="1">
                        Action
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    {orders &&
                      orders.map((order) => (
                        <tr className="odd" role="row" key={order._id}>
                          <td className="sorting_1">{order.OrderId}</td>
                          <td>{order.PaymentType}</td>
                          <td>{order.Status}</td>
                          <td>{order.TestDate} {order.Slot}</td>
                          <td>
                            
                              <button onClick={()=>{
                                history.push(
                                  `/all-order-list/${order._id}/${
                                    activePag.current
                                  }/${Math.round(window.scrollY)}/centerOrders`,
                                  {orders:orders,centerId:id}
                                );
                              }} className="btn btn-primary">View</button>
                            
                          </td>

                          <td>
                            {order.OrderStatus === "Pending" &&
                              order.PaidOnline && (
                                <button
                                  onClick={() => {
                                    setFindRider(true);
                                    setShow(true);
                                    setOrderId(order._id);
                                    setUserId(order.Address[0]._id);
                                  }}
                                  style={{ fontSize: 10 }}
                                  className="btn btn-primary"
                                >
                                  Find Riders
                                </button>
                              )}
                            {order.OrderStatus === "Pending" &&
                              !order.PaidOnline && (
                                <button
                                  onClick={() => {
                                    setShow1(true);
                                    setOrderId(order._id);
                                    setUserId(order.Address[0]._id);
                                  }}
                                  className="btn btn-primary"
                                >
                                  Delete
                                </button>
                              )}
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              )}
              {!orders && (
                <Alert
                  variant="success"
                  className="alert-dismissible fade show text-center"
                >
                  Zero Orders
                </Alert>
              )}
              <div className="d-sm-flex text-center justify-content-between align-items-center mt-3">
                <div className="dataTables_info text-white">
                  Showing {activePag.current * sort + 1} to{" "}
                  {data.length > (activePag.current + 1) * sort
                    ? (activePag.current + 1) * sort
                    : data.length}{" "}
                  of {data.length} entries
                </div>
                <div
                  className="dataTables_paginate paging_simple_numbers"
                  id="example5_paginate"
                >
                  <Link
                    className="paginate_button previous disabled"
                    onClick={() =>
                      activePag.current > 0 && onClick(activePag.current - 1)
                    }
                  >
                    Previous
                  </Link>
                  <span>
                    {paggination.map((number, i) => (
                      <Link
                        key={i}
                        className={`paginate_button  ${
                          activePag.current === i ? "current" : ""
                        } `}
                        onClick={() => onClick(i)}
                      >
                        {number}
                      </Link>
                    ))}
                  </span>
                  <Link
                    className="paginate_button next"
                    onClick={() => {
                      activePag.current + 1 < paggination.length &&
                        onClick(activePag.current + 1);
                    }}
                  >
                    Next
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewOrdersList;
